import styled from '@emotion/styled';
import { Button } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const ApplyButton = styled(Button)``;

export const QuizWrapper = styled.div`
  padding: 15px 0;
  color: ${(props) => props.theme.color.dark.default};
  font-weight: 600;
  display: inline-flex;
  align-items: center;

  ${mediaQuery('phone')} {
    flex-direction: column;
    text-align: center;
    width: 100%;
  }
`;

export const ButtonWrapper = styled(Button)`
  margin-left: 15px;
  width: auto;
  ${mediaQuery('phone')} {
    margin: 0;
    margin-top: 10px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  ${mediaQuery('phone')} {
    flex-direction: column;
    text-align: center;
    width: 100%;
  }
`;
